var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCutIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 32,
    height: 32,
    rx: 10,
    fill: "#100F15"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7,7) scale(0.84)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 17.5,
    r: 2.5,
    fill: "none",
    stroke: "#100F15",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 2.5,
    fill: "none",
    stroke: "#100F15",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.6,
    y1: 15.8,
    x2: 21,
    y2: 4,
    stroke: "#100F15",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.6,
    y1: 8.2,
    x2: 21,
    y2: 20,
    stroke: "#100F15",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutIcon);
export default __webpack_public_path__ + "static/media/cutIcon.2d8e37b8842c29fcc66ade610ce5fa0c.svg";
export { ForwardRef as ReactComponent };